import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Modal,
  IconButton,
  Chip,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95vw", sm: "80vw", md: "70vw" },
  maxHeight: "85vh",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
};

const fmtDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("pl-PL", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};

const DetailModal = ({ open, onClose, title, rows, type, formatCurrency }) => (
  <Modal open={open} onClose={onClose}>
    <Box sx={modalStyle}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2, borderBottom: 1, borderColor: "divider" }}>
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
      </Box>
      <Box sx={{ overflow: "auto", flex: 1 }}>
        {rows.length === 0 ? (
          <Typography sx={{ p: 3 }} color="text.secondary">Brak rekordów.</Typography>
        ) : type === "passes" ? (
          <TableContainer>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Klient</TableCell>
                  <TableCell>Typ karnetu</TableCell>
                  <TableCell>Data zakupu</TableCell>
                  <TableCell>Lokalizacja</TableCell>
                  <TableCell align="right">Kwota</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((r) => (
                  <TableRow key={r.pass_id} hover>
                    <TableCell>{r.user_name}</TableCell>
                    <TableCell>{r.pass_type_name}</TableCell>
                    <TableCell>{fmtDate(r.created_at)}</TableCell>
                    <TableCell>{r.location_name || <Chip label="brak" size="small" />}</TableCell>
                    <TableCell align="right">{formatCurrency(r.amount)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TableContainer>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Klient</TableCell>
                  <TableCell>Zajęcia</TableCell>
                  <TableCell>Data</TableCell>
                  <TableCell>Lokalizacja</TableCell>
                  {type === "admin" && <TableCell>Zatwierdził</TableCell>}
                  <TableCell align="right">Kwota</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((r) => (
                  <TableRow key={`${r.user_id}-${r.lesson_id}`} hover>
                    <TableCell>{r.user_name}</TableCell>
                    <TableCell>{r.lesson_name}</TableCell>
                    <TableCell>{fmtDate(r.lesson_date)}</TableCell>
                    <TableCell>{r.location_name || <Chip label="brak" size="small" />}</TableCell>
                    {type === "admin" && <TableCell>{r.cleared_by_name || "—"}</TableCell>}
                    <TableCell align="right">{formatCurrency(r.amount)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  </Modal>
);

export default DetailModal;
